import React from "react";
import { useGlobalContext } from "./context/globalContext";

const AboutDeveloper = () => {
  const { handleShowModal } = useGlobalContext();

  return (
    <section className="section shadow-sm lazyloaded" id="developer">
      <div className="row">
        <div className="col-md-8">
          <h2 className="d-block section-heading-sub text-capitalize">
            About Developer
          </h2>
        </div>
        <div className="col-md-4">
          <button
            className="btn btn-info micro-form-btn enqModal effetMoveGradient effectScale download_brochure float-lg-right d-none d-lg-block"
            onClick={() => handleShowModal("AboutDev ChatWithUs")}
          >
            Chat with us
          </button>
          {/* sfsdfs */}
        </div>
      </div>

      <p>
        L&T Realty is one of India's leading real estate developers, known for
        its excellence in construction, innovative designs, and premium
        developments. With a strong presence in Mumbai, Bangalore, and Chennai,
        L&T Realty is dedicated to delivering high-quality homes that enhance
        urban living. The launch of L&T Wagle Estate Thane further strengthens
        its commitment to providing luxurious, well-connected, and future-ready
        residences.
      </p>

      <button
        className="btn btn-info micro-form-btn enqModal effetMoveGradient effectScale download_brochure float-lg-right mx-sm-auto d-lg-none"
        data-form="lg"
        data-title=" Chat with us"
        data-btn=" Chat with us"
        data-enquiry="Download Brochure Left Panel"
        data-redirect="enquiry"
        data-toggle="modal"
        data-target="#enqModal"
        onClick={() => handleShowModal("AboutDev ChatWithUs")}
      >
        Chat with us
      </button>
    </section>
  );
};

export default AboutDeveloper;
